/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import React, {useEffect, useState} from "react";
import {Badge, Layout, Menu} from "antd";
import {Link, useLocation} from "react-router-dom";

import {IconSet} from "./icons";
import {useAppSelector} from "../store";
import NotificationBadge from "./notificationBadge";
import {getUserInfo} from "../core/auth/authentication";

export default function Sider(props: any) {
    const [collapsed, setCollapsed] = useState(false);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const userInfo = useAppSelector(state => state.auth.userInfo);
    const groups = userInfo ? (userInfo['groups'] ? userInfo['groups'] : []) : []
    const isAdmin = groups.includes('admin')

    const personId = useAppSelector(state => state.auth?.userInfo?.person_id);

    const location = useLocation();

    const reloadSignalsTodos = [useAppSelector(state => state.reloadSignals.todo)]

    const selection_lut = {
        'customers': ['customers'],
        'devices': ['devices'],
        'persons': ['persons'],
        'users': ['settings', 'users'],
        'models': ['settings', 'models'],
        'eventfilters': ['settings', 'eventfilters'],
        'documentation': ['documentation'],
        'todos': ['todos'],
    }

    useEffect(() => {
        console.log("personId", personId)
    }, [personId])

    useEffect(() => {
        let root = location.pathname.split('/')[1]
        if (root in selection_lut) {
            // @ts-ignore
            setSelectedKeys(selection_lut[root])
        } else {
            setSelectedKeys([])
        }
        console.debug("Sider: location changed", location)
    }, [location])

    return (
        <Layout.Sider collapsedWidth={48} theme="light" collapsible onCollapse={(c) => setCollapsed(c)}
                      defaultCollapsed={false}>
            <Menu theme='light'
                  selectable={false}
                  mode='vertical'
                  selectedKeys={selectedKeys}
                  items={[
                      {key: "home", icon: <IconSet type={'home'}/>, label: <Link to='/'>Home</Link>},
                      {key: "customers", icon: <IconSet type='customers'/>, label: <Link to='/customers'>Kunden</Link>},
                      {key: "devices", icon: <IconSet type='devices'/>, label: <Link to='/devices'>Geräte</Link>},
                      {key: "persons", icon: <IconSet type='persons'/>, label: <Link to='/persons'>Kontakte</Link>},
                      ...(personId ? [{key: "todos", icon: <IconSet type='note'/>, label:<Link style={{ color: "inherit" }} to='/todos'>Todos <NotificationBadge countSource={ "/api/v1/todos/count?person=" + personId } reloadSignal={reloadSignalsTodos}/> </Link>}] : []),
                      {
                          disabled: !isAdmin,
                          key: "settings", icon: <IconSet type={'settings'}/>,
                          // @ts-ignore
                          label: "Verwaltung",
                          children: [
                              {key: "users", icon: <IconSet type='users'/>, label: <Link to='/users'>Nutzer</Link>},
                              {
                                  key: "models", icon: <IconSet type='models'/>,
                                  label: <Link to='/models'>Geräte-Modelle</Link>
                              },
                              {
                                  key: "eventfilters", icon: <IconSet type='filter'/>,
                                  label: <Link to='/eventfilters'>Filter</Link>
                              },
                          ]
                      },
                      {
                          key: "documentation",
                          icon: <IconSet type='documentation'/>,
                          label: <Link to='/documentation'>Handbuch</Link>
                      }
                  ]}
            />
        </Layout.Sider>
    );
}